import React from 'react';
import styled from '@emotion/styled';
import { css, SerializedStyles } from '@emotion/react';

export interface TableProps {
  styles?: SerializedStyles;
}
const TableWrapper = styled.table`
  width: 100%;
  font-family: Noto Sans KR;
  font-style: normal;
  font-size: 14px;
  line-height: 20px;
  text-align: left;
  border-spacing: 1px;
  margin-top: 20px;
  tr {
    height: 40px;
  }
  th {
    box-sizing: border-box;
    padding: 0 16px 0 22px;
    background: #999;
    font-weight: bold;
    color: #fff;
    border-left: 4px solid #ccc;
  }
  td {
    padding: 0 30px;
    color: #333;
    background: #fff;
  }

  &.active {
    & th {
      border-left: 4px solid #7fe200;
      background-color: #00bf00;
    }
  }

  @media (max-width: 412px) {
    height: 100%;
    tbody {
      width: 100%;
    }
    tr {
      display: grid;
      height: auto !important;
    }
  }
  ${(props: TableProps) => props.styles};
`;
const HorizontalTable = ({ className, styles = css``, children }: any) => {
  return (
    <TableWrapper styles={styles} className={className}>
      {children}
    </TableWrapper>
  );
};

export default HorizontalTable;
